<dackl-explicit-search class="leading-[0] flex items-center"
   placeholder="{{ 'search-slot-slim.search_placeholder' | translate }}"
   (input)="onSearchTermChange($event)"
   (searchButtonPressed)="search()" (keydown.shift.enter)="search()"
   (clearButtonPressed)="clear()">
</dackl-explicit-search>
